@if (hasSectionData) {
  <section class="features-section">
    <div class="features-section-container">
      <div class="section-header">
        <div class="header-content">
          <h2 class="headline">{{ headline | translateLang }}</h2>
          @if (eyebrowText) {
            <div class="eyebrow-heading">
              <!-- @if (eyebrowIcon) {
                <mat-icon
                  [svgIcon]="eyebrowIcon"
                  class="eyebrow-icon"
                  [style.color]="eyebrowIconColor"
                  [attr.aria-label]="eyebrowText">
                </mat-icon>
              } -->
              <p class="eyebrow-text">{{ eyebrowText | translateLang }}</p>
            </div>
          }
        </div>
        <a
          class="view-all-button app-button yellow"
          [routerLink]="getViewAllLink()"
          (click)="handleButtonClick()">
          <p>{{ buttonLabel | translateLang }}</p>
        </a>
      </div>
      <mat-tab-group
        mat-stretch-tabs="false"
        mat-align-tabs="start"
        class="tabs-container"
        [(selectedIndex)]="selectedTabIndex"
        (selectedIndexChange)="tabChanged($event)"
        >
        @for (tab of tabs; track tab.label; let tabIndex = $index) {
          @if (tab.cards.length > 0) {
            <mat-tab [label]="tab.label | translateLang">
              <div class="pagination-text">{{ currentPage }} of {{ totalCards }}</div>
              <div class="cards-carousel">
                @if (showCarouselBtns[tabIndex]) {
                  <button class="nav-arrow nav-arrow-left" (click)="previousCards()">
                    <img src="/assets/images/icons/arrow-left.svg" alt="Previous" class="nav-arrow-icon" />
                  </button>
                }
                <div
                  class="cards-container"
                  [ngStyle]="getContainerStyle()">
                  @for (card of visibleCards; track card.uuid; let i = $index) {
                    <div
                      class="card-wrapper"
                      [class.is-top-card]="i === 0"
                      (touchstart)="onTouchStart($event, i)"
                      (touchmove)="onTouchMove($event, i)"
                      (touchend)="onTouchEnd($event, i)"
                      [ngStyle]="getCardStackStyle(i)">
                      <app-featured-card
                        [card]="card"
                        [showOrgInfo]="tab.type === 'project'"
                        [showProgress]="tab.type === 'project'"
                        [contentHeight]="tab.type === 'project' ? 325 : undefined"
                        [giveUrl]="getGiveUrl()"
                        [learnMoreUrl]="getLearnMoreUrl(card)"
                        [attr.data-card-index]="i"
                        [attr.data-card-uuid]="card.uuid"
                        (giveClick)="handleGiveClick($event)"
                        (learnMoreClick)="handleLearnMoreClick($event)">
                      </app-featured-card>
                    </div>
                  }
                </div>
                @if (showCarouselBtns[tabIndex]) {
                  <button class="nav-arrow nav-arrow-right" (click)="nextCards()">
                    <img src="/assets/images/icons/arrow-right.svg" alt="Next" class="nav-arrow-icon" />
                  </button>
                }
              </div>

              @if (showCarouselIndicators[tabIndex]) {
                <div class="card-carousel-indicators">
                  @for (page of [].constructor(totalPages); track $index; let i = $index) {
                    <span
                      class="indicator"
                      [class.active]="i === currentPage - 1"
                      (click)="goToPage(i)">
                    </span>
                  }
                </div>
              }
            </mat-tab>
          }
        }
      </mat-tab-group>
    </div>
  </section>
}
